import React, {useEffect, useState} from "react";
import {useNavigate, Link} from "react-router-dom";
import TimeOutModal from "../Assets/TimeOutModal";

import useInput from "../Assets/UseInput";
import {useTranslation} from "react-i18next";
import {Col, Alert, Form, FormFeedback, FormGroup, Input, InputGroup, Button, InputGroupText, Label, Row} from "reactstrap";
import BreadCrumb from "../Layout/BreadCrumb";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


var serialize = require('serialize-javascript');

function JobIndependant (props) {
    // fetch data from local Storage
    let history = useNavigate();
const [d, setDead] = useState()
    const [isLoading, setIsLoading] = useState(false);
    const { i18n } = useTranslation();


    //specific constant if needed
    const [JobPartner, setJobPartner]=useState(false)
    const [stored, setStored] =  useState("")

    const [jobCheckbox, setJobCheckbox] = useState({});


    const next = () =>{
        let nextLocation = {}

        if (jobCheckbox.etudiant){
            nextLocation = {
                pathname: '../job-student',
                state: { d: d }
            }
        }else if (d && JobPartner) {
            nextLocation = {
                pathname: '../job-partner',
                state: { d: d }
            }
        }else {
            nextLocation = {
                pathname: '../circumstances',
                state: { d: d }
            }
        }
        history(nextLocation)
    }

    const handleNext = (e) =>{
        e.preventDefault()
        next()
    }

    const prevLocation = {
        pathname: '../information',
        state: { d: d }
    }
    const handlePrev = (e) =>{
        e.preventDefault()
        history(prevLocation)
    }

    // set control value and name to classic Inputs using the custom Hook useInput
    const {value: Field40StatusBenefice, bind: bindField40StatusBenefice, reset: setField40StatusBenefice} = useInput('')
    const {value: Field40StatusFrais, bind: bindField40StatusFrais, reset: setField40StatusFrais} = useInput('')
    

    const {value: Field39BCE, bind: bindField39BCE, reset: setField39BCE} = useInput('')



    const [Field38Titre, setField38Titre] = useState("");
    //  Input radio change
    const handleChangeField38Titre = (e) => {
        let value = e.target.value
        setField38Titre(value);
    }
    const [Field40Status, setField40Status] = useState("");
    //  Input radio change
    const handleChangeField40Status = (e) => {
        let value = e.target.value
        setField40Status(value);
    }
    const [Field39BCEempty, setField39BCEempty] = useState(false);
    //  Input radio change
    const handleChangeField39BCEempty = (e) => {
        let value = e.target.value
        setField39BCEempty(!Field39BCEempty);
    }
    useEffect(() => {
        window.scrollTo(0, 0)
        const fetchData = async () => {
            setIsLoading(true);
            const dead = localStorage.getItem('isDead')
            //console.log(dead)
            dead === "true" ? setDead(true) : setDead(false)
            //setDead(false)
             let jobPartner = localStorage.getItem("hasActivePartner")
            jobPartner === 'true' ? setJobPartner(true) : setJobPartner(false)
            setIsLoading(false);

            const job = JSON.parse(localStorage.getItem('job'))

            if (job){
                setStored(true)
                setJobCheckbox(job.checkbox)
            }

            const jobIndependant = JSON.parse(localStorage.getItem('jobIndependant'))

            if (jobIndependant){
                setStored(true)
                setField38Titre(jobIndependant.Field38Titre)
                setField39BCE(jobIndependant.Field39BCE)
                setField40Status(jobIndependant.Field40Status)
                setField40StatusBenefice(jobIndependant.Field40StatusBenefice)
                setField40StatusFrais(jobIndependant.Field40StatusFrais)
                setField39BCEempty(jobIndependant.Field39BCEempty)

            }
        };
        fetchData()
    }, []);

    // Submit and validation
    const [NotValid, setNotValid] = useState(false)
    const handleSubmit = (evt) => {

                    window.scrollTo(0, 0)
        evt.preventDefault();

        let notValid = Field38Titre === "" || Field40StatusFrais ==="" || Field40StatusBenefice === "" || Field40StatusFrais ==="0" || Field40StatusBenefice === "0" || (Field39BCE === "" && !Field39BCEempty )

      //console.log(notValid)
        setNotValid(notValid)
        if (!notValid){
            let jobIndependant = {
                Field38Titre:Field38Titre,
                Field39BCE: Field39BCE,
                Field40Status:Field40Status,
                Field40StatusBenefice:Field40StatusBenefice,
                Field40StatusFrais:Field40StatusFrais,
                Field39BCEempty:Field39BCEempty,

            }
            //let stringInfo = JSON.stringify(jobIndependant)
            let stringInfo = serialize(jobIndependant, {isJSON: true});
            localStorage.setItem("jobIndependant" , stringInfo)
            //console.log(JSON.parse(stringInfo))
            next()
        }

    }

    return (
        <div className={d? "death" : "injured"}>
            { !!isLoading ? (
                    <div className={'text-center pt-5'}><img className={'d-inline-block'} src="/accidentinfo/spinner.svg" alt=""/></div>
                ) :
                <div className={"container"}>
                    <TimeOutModal i18n={i18n} />
<BreadCrumb n={4}/>
                    <Row>
                        <Col>
                            <h3>{d?  i18n.t('JOBTITLEDEATH') : i18n.t('JOBTITLE') }</h3>
                            <h4 className={"text-primary"}>{d?  i18n.t("Le défunt était indépendant(e)") : i18n.t("Vous êtes indépendant(e)") }</h4>
                           <Alert color="warning">
                                <span className="glyphicon glyphicon-record"/>
                                <strong>{i18n.t("Attention")}</strong>
                                <hr className="message-inner-separator"/>
                                <p>{i18n.t("joindre avertissement")}</p>
                            </Alert>
                            { NotValid &&
                            <Alert color="danger"><FontAwesomeIcon className="pre" icon={['fas', 'hand-point-right']} /> <strong>{  i18n.t('Erreur(s) dans votre formulaire') }</strong>
                                <hr className="message-inner-separator"/>
                                <p>{i18n.t('Merci de vérifier les champs indiqués en rouge')}</p></Alert>
                            }
                            <Form>
                                <div className="formlevel01">
                                    <FormGroup>
                                        <Label for="Field38Titre" className={(NotValid && Field38Titre === "") ? "text-danger" : "text"}>{d? i18n.t("field38Titre") : i18n.t("field38Titre")} <span className={"text-danger"}>*</span></Label>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio" onChange={handleChangeField38Titre} name="Field38Titre" value="principal" checked={Field38Titre === "principal"}/>
                                                 &nbsp;{i18n.t("principal")}
                                            </Label>
                                        </div>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio"  onChange={handleChangeField38Titre}  name="Field38Titre" value="accessoire" checked={Field38Titre === "accessoire"}/>
                                                 &nbsp;{i18n.t("accessoire")}
                                            </Label>
                                        </div>
                                        <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="Field39BCE">{ i18n.t("field39BCE")} <span className={"text-danger"}>*</span></Label>
                                        <Input type="text" maxLength={500} {...bindField39BCE} placeholder={d? i18n.t("placeholderfield39BCE") : i18n.t("placeholderfield39BCE")} invalid={(NotValid && (Field39BCE === "" && !Field39BCEempty))? true : undefined}/>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="checkbox"  onChange={handleChangeField39BCEempty}  name="Field39BCEempty"  checked={Field39BCEempty} />
                                                &nbsp;{ d? i18n.t("Le défunt n’avait pas de numéro BCE") : i18n.t("Je n’ai pas de numéro BCE")}
                                            </Label>
                                        </div>
                                        <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="Field40Status" className={(NotValid && Field40Status === "") ? "text-danger" : "text"}>{d? i18n.t("Le défunt était") : i18n.t("Vous êtes")} <span className={"text-danger"}>*</span></Label>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio" onChange={handleChangeField40Status} name="Field40Status" value="dirigeant" checked={Field40Status === "dirigeant"}/>
                                                 &nbsp;{i18n.t("dirigeant")}
                                            </Label>
                                        </div>
                                        { Field40Status === "dirigeant" &&
                                        <div className={"formlevel02"}>
                                            <FormGroup>
                                                <Label>{i18n.t("field40StatusBenefice")} <span className={"text-danger"}>*</span></Label>
                                                <InputGroup>
                                                    <div className={"input-group-prepend"}>
                                                        <FontAwesomeIcon className="pre" icon={['fas', 'euro']} />
                                                    </div>
                                                    <Input type={"text"} name={"Field40StatusBenefice"} {...bindField40StatusBenefice} placeholder={d? i18n.t("placeholderfield40StatusBeneficeDeath") : i18n.t("placeholderfield40StatusBenefice")} invalid={NotValid && (Field40StatusBenefice==="0" || !Field40StatusBenefice) } />
                                                <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                                </InputGroup>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>{i18n.t("field40StatusFrais")}  <span className={"text-danger"}>*</span></Label>
                                                <InputGroup>
                                                    <div className={"input-group-prepend"}>
                                                        <FontAwesomeIcon className="pre" icon={['fas', 'euro']} />
                                                    </div>
                                                    <Input type={"text"} {...bindField40StatusFrais} placeholder={d? i18n.t("placeholderfield40StatusFraisDeath") : i18n.t("placeholderfield40StatusFrais")} invalid={NotValid && (Field40StatusFrais==="0"|| !Field40StatusFrais)} />
                                                <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                                </InputGroup>
                                            </FormGroup>
                                            {!Field40StatusBenefice && !Field40StatusFrais && NotValid && <span className={"help-block text-danger"}>{i18n.t("Obligatoire")}</span>}

                                        </div>
                                        }
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio"  onChange={handleChangeField40Status}  name="Field40Status" value="societe" checked={Field40Status === "societe"}/>
                                                 &nbsp;{i18n.t("societe")}
                                            </Label>
                                        </div>
                                        { Field40Status === "societe" &&
                                        <div className={"formlevel02"}>
                                            <FormGroup>
                                                <Label>{i18n.t("field40StatusBenefice")} <span className={"text-danger"}>*</span></Label>
                                                <InputGroup>
                                                    <div className={"input-group-prepend"}>
                                                        <FontAwesomeIcon className="pre" icon={['fas', 'euro']} />
                                                    </div>
                                                    <Input type={"text"} name={"Field40StatusBenefice"} {...bindField40StatusBenefice} placeholder={d? i18n.t("placeholderfield40StatusBeneficeDeath") : i18n.t("placeholderfield40StatusBenefice")} invalid={NotValid && (Field40StatusBenefice==="0" || !Field40StatusBenefice) } />
                                                <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                                </InputGroup>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>{i18n.t("field40StatusFrais")}  <span className={"text-danger"}>*</span></Label>
                                                <InputGroup>
                                                    <div className={"input-group-prepend"}>
                                                        <FontAwesomeIcon className="pre" icon={['fas', 'euro']} />
                                                    </div>
                                                    <Input type={"text"} {...bindField40StatusFrais} placeholder={d? i18n.t("placeholderfield40StatusFraisDeath") : i18n.t("placeholderfield40StatusFrais")} invalid={NotValid && (Field40StatusFrais==="0"|| !Field40StatusFrais)} />
                                                <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                                </InputGroup>
                                            </FormGroup>
                                            {!Field40StatusBenefice && !Field40StatusFrais && NotValid && <span className={"help-block text-danger"}>{i18n.t("Obligatoire")}</span>}

                                        </div>
                                        }
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio"  onChange={handleChangeField40Status}  name="Field40Status" value="personnephysique" checked={Field40Status === "personnephysique"}/>
                                                 &nbsp;{i18n.t("personnephysique")}
                                            </Label>
                                        </div>
                                        { Field40Status === "personnephysique" &&
                                        <div className={"formlevel02"}>
                                            <FormGroup>
                                                <Label>{i18n.t("field40StatusBenefice")} <span className={"text-danger"}>*</span></Label>
                                                <InputGroup>
                                                    <div className={"input-group-prepend"}>
                                                        <FontAwesomeIcon className="pre" icon={['fas', 'euro']} />
                                                    </div>
                                                    <Input type={"text"} name={"Field40StatusBenefice"} {...bindField40StatusBenefice} placeholder={d? i18n.t("placeholderfield40StatusBeneficeDeath") : i18n.t("placeholderfield40StatusBenefice")} invalid={NotValid && (Field40StatusBenefice==="0" || !Field40StatusBenefice) } />
                                                <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                                </InputGroup>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>{i18n.t("field40StatusFrais")}  <span className={"text-danger"}>*</span></Label>
                                                <InputGroup>
                                                    <div className={"input-group-prepend"}>
                                                        <FontAwesomeIcon className="pre" icon={['fas', 'euro']} />
                                                    </div>
                                                    <Input type={"text"} {...bindField40StatusFrais} placeholder={d? i18n.t("placeholderfield40StatusFraisDeath") : i18n.t("placeholderfield40StatusFrais")} invalid={NotValid && (Field40StatusFrais==="0"|| !Field40StatusFrais)} />
                                                <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                                </InputGroup>
                                            </FormGroup>
                                            {!Field40StatusBenefice && !Field40StatusFrais && NotValid && <span className={"help-block text-danger"}>{i18n.t("Obligatoire")}</span>}

                                        </div>
                                        }
                                        <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                    </FormGroup>




                                    { !stored &&
                                    <div className="button-wrapper">
                                        <button type="submit"  onClick={handleSubmit} className="btn btn-primary small">{  i18n.t('Enregistrer') }<FontAwesomeIcon icon={['fas', 'arrow-right']} /></button>
                                    </div>
                                    }
                                    { stored &&
                                    <div className="button-wrapper">
                                        <button type="submit"  onClick={handleSubmit} className="btn btn-primary small">{  i18n.t('Mettre à jour') }<FontAwesomeIcon icon={['fas', 'arrow-right']} /></button>
                                    </div>
                                    }
                                </div>
                            </Form>

                            <span className={"text-danger"}>* </span> {  i18n.t('Renseignement indispensable') }<br />
                        </Col>
                    </Row>
                    
                </div>}
        </div>
    )
}
export default JobIndependant

